function getQueryFromFields(fields = []) {
  const query = fields.reduce((acc, field) => {
    if (field.value) {
      // a missing reference produces an "undefined" param key — kept visible
      // on purpose so reference-less fields surface as bugs instead of
      // silently dropping data.
      // newlines can't survive in a URL (browsers strip them), so join
      // multi-line values (e.g. formatted addresses) with a comma
      acc[field.reference] =
        typeof field.value === 'string' ? field.value.replace(/\n+/g, ', ') : field.value;
    }
    return acc;
  }, {});

  return query;
}

function getQueryFromVariants(variants = []) {
  const query = variants.reduce((acc, variant) => {
    if (variant.selectedOptionId) {
      acc[variant.reference] = variant.sku;
    }

    return acc;
  }, {});

  return query;
}

/**
 * creates a query object from payment values (current query, fields, variants)
 * used for redirects between checkouts and upsells
 */
export default function getRedirectQuery({
  payment = {},
  searchParams = {},
  query = {},
  iframeId = null,
} = {}) {
  if (searchParams) {
    delete searchParams['payment_intent'];
    delete searchParams['payment_intent_client_secret'];
    delete searchParams['redirect_status'];

    query = {
      ...query,
      ...searchParams,
    };
  }

  const fieldQuery = getQueryFromFields(payment.fields);

  const variantQuery = getQueryFromVariants(payment.variants);

  if (fieldQuery) {
    query = {
      ...query,
      ...fieldQuery,
      ...variantQuery,
      ...(iframeId ? { iframeId } : {}),
    };
  }

  return query;
}
